module.exports = __webpack_public_path__ + "img/urn_of_shadows.ee5e3059.png";